export class IssuerType {
    constructor(public id: string) {}
}
